export const BASE_PATH = `/cycle-hangars`;
export const RoutesList = {
  LANDING_PAGE: '/',
  CALLBACKS: BASE_PATH + '/callbacks/*',
  HOME: BASE_PATH,
  UPLOAD_PHOTO: BASE_PATH + '/upload-photo',
  DETAILS: BASE_PATH + '/cycle-hangar-details',
  LOCATION: BASE_PATH + '/cycle-hangar-location',
  ISSUES: BASE_PATH + '/cycle-hangar-issues',
  CONFIRMATION: BASE_PATH + '/confirmation',
  ISSUE_LOCATION: BASE_PATH + '/issue-location',
  ISSUE_SELECTION: BASE_PATH + '/what-is-the-issue',
  CYCLE_HANGAR_SECURE: BASE_PATH + '/cycle-hangar-secure',
  CODE_MATCH: BASE_PATH + '/code-match',
  KEY_TURN: BASE_PATH + '/key-turn',
  LOCK_CODE_DETAILS: BASE_PATH + '/lock-code-details',
  BIKE_THEFT: BASE_PATH + '/bike-theft',
  CLEANING: BASE_PATH + '/cleaning-needed',
  ABANDONED_OR_UNAUTHORISED: BASE_PATH + '/abandoned-or-unauthorised-bikes',
  ABANDONED_OR_UNAUTHORISED_DESCRIBE:
    BASE_PATH + '/abandoned-or-unauthorised-bikes-provide-description',
  SOMETHING_ELSE: BASE_PATH + '/something-else',
  TELL_US_MORE: BASE_PATH + '/tell-us-more',
  DAMAGED_OR_VANDALISED: BASE_PATH + '/damaged-or-vandalised',
  DAMAGED_OR_VANDALISED_TELL_US_MORE:
    BASE_PATH + '/damaged-or-vandalised-tell-us-more',
  YOUR_DETAILS: BASE_PATH + '/your-details',
  EMAIL_CONFIRMATION_REPORT: BASE_PATH + '/email-confirmation-report',
  NOT_FOUND: '*',
  INTERNAL_SERVER_ERROR: '/500',
};

export const steps = [
  {
    label: 'Upload photo',
    urlPaths: [RoutesList.UPLOAD_PHOTO],
  },
  {
    label: 'Issue details',
    urlPaths: [
      RoutesList.DETAILS,
      RoutesList.ISSUES,
      RoutesList.LOCATION,
      RoutesList.ISSUE_LOCATION,
      RoutesList.ISSUE_SELECTION,
      RoutesList.CYCLE_HANGAR_SECURE,
      RoutesList.BIKE_THEFT,
      RoutesList.CODE_MATCH,
      RoutesList.KEY_TURN,
      RoutesList.LOCK_CODE_DETAILS,
      RoutesList.CLEANING,
      RoutesList.ABANDONED_OR_UNAUTHORISED,
      RoutesList.ABANDONED_OR_UNAUTHORISED_DESCRIBE,
      RoutesList.SOMETHING_ELSE,
      RoutesList.TELL_US_MORE,
      RoutesList.DAMAGED_OR_VANDALISED,
      RoutesList.DAMAGED_OR_VANDALISED_TELL_US_MORE,
    ],
  },
  {
    label: 'Your details',
    urlPaths: [RoutesList.YOUR_DETAILS, RoutesList.EMAIL_CONFIRMATION_REPORT],
  },
];
